import React, { useState, useEffect } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'semantic-ui-react';
import styles from './Explore.module.scss';
import dashboardStyles from '../Dashboard.module.scss';
import { getNearbyEvents } from 'legacy/actions/eventActions';
import { RANGE_OPTIONS } from '../../../../util/constants';
import { addElipsesAfterLength } from '../../../../util/util';
import { useDeepCompareMemoize } from '../../../../util/hooks';
import { logEvent } from 'legacy/common/utils/amplitude';
import { EVENT_CLICK_NEARBY_EVENT } from 'legacy/common/constants/events';
import Loader from 'legacy/common/components/layout/Loader';

const NearbyEventPreview = ({ event, onClick }) => {
  const { t } = useTranslation('dashboard');
  const start = moment(event.startDate);
  return (
    <div key={event._id} className="event" onClick={onClick}>
      <div>
        <div>
          <div
            className="pic"
            style={{
              backgroundImage:
                event.photo && event.photo.url
                  ? `url(${event.photo.url})`
                  : 'url(/img/defaultPhoto.svg)',
              backgroundSize: 'cover'
            }}
          >
            <div className="distance">
              {event.distance === undefined
                ? ''
                : `${(event.distance / 1000).toFixed(1)} ${t(
                    'explore.kmUnit'
                  )}`}
            </div>
          </div>
          <div className="info">
            <div className={styles.nearbyEventTitle}>{event.title}</div>
            <div className="bn-row subtext">
              <div className="time">{start.format('DD/MM/YYYY')}</div>
              {/* add location */}
            </div>
            <p className="description dotdotdot">
              {addElipsesAfterLength(event.description, 60)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

function Explore({
  events,
  nearbyEvents,
  getNearbyEvents,
  navigateToEvent,
  device
}) {
  const router = useRouter();
  const { t } = useTranslation('dashboard');
  const [range, setRange] = useState(50);
  const geolocation = useDeepCompareMemoize(events.geolocation);
  const url = router.pathname;

  useEffect(() => {
    if (geolocation) {
      getNearbyEvents({
        lat: geolocation.lat,
        long: geolocation.long,
        range: range * 1000
      });
    } else {
      getNearbyEvents({ range: range * 1000 });
    }
  }, [geolocation, range]);

  const nearbyEventPreviews = nearbyEvents.map((event) => (
    <NearbyEventPreview
      key={event._id}
      event={event}
      onClick={() => {
        const eventOptions = {
          event_id: event._id,
          url
        };
        logEvent(EVENT_CLICK_NEARBY_EVENT, eventOptions);
        navigateToEvent(event._id);
      }}
    />
  ));

  const placeholder = (
    <div className="placeholder">
      <div>
        <div>
          <img src="/img/illustrations/createYourOwn.svg" alt="" />
          <h2>{t('explore.createYourOwnEvent')}</h2>
          {nearbyEvents.length > 0 ? (
            <span>{t('explore.reachedBottom')}</span>
          ) : (
            <span>{t('explore.nothingElseHere')}</span>
          )}
          <div className="bn-btn primary" onClick={() => router.push('/host')}>
            {t('explore.startTheFun')}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={classnames(
        'bn-container nearby-events',
        styles.Explore,
        device
      )}
    >
      <div className={dashboardStyles.cardHeader}>
        <span
          className={dashboardStyles.cardTitle}
          style={{ marginRight: '10px' }}
        >
          {t('explore.title')}
        </span>
        <span>
          <Dropdown
            compact
            selection
            options={RANGE_OPTIONS.map((r) => ({
              key: r,
              value: r,
              text: `${r}${t('explore.kmUnit')}`
            }))}
            defaultValue={50}
            onChange={(e, { value }) => setRange(Number(value))}
          />
        </span>
      </div>

      <Loader isLoading={events.loading.GET_NEARBY_EVENTS} isOverlay>
        <div className="content">
          <div className="section events">
            {nearbyEventPreviews}
            {placeholder}
          </div>
        </div>
      </Loader>
    </div>
  );
}

const mapStateToProps = (state) => ({ events: state.events });

const actions = { getNearbyEvents };

export default connect(mapStateToProps, actions)(Explore);
